
















import {Vue, Component, PropSync} from 'vue-property-decorator';
import CompSelectBox from '@/components/common/CompSelectBox.vue';

@Component({
  components: {
    CompSelectBox
  }
})
export default class TaskMessageSearchTypeSelect extends Vue{
  @PropSync('taskMessageSearchType')
  private taskMessageSearchTypeSync!: 'ALL' | 'PROCESSING' | 'EXCLUDE_PROCESSING';

  private taskMessageSearchTypes = [
    {value: 'ALL', name: 'ORDER_ORDER_CONTENT_TOP_ALL'},
    {value: 'PROCESSING', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_PROCESSING'},
    {value: 'DONE', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_DONE'},
    {value: 'PROCESSING_DONE', name: 'ORDER_ORDER_CONTENT_TOP_TASK_MESSAGE_SEARCH_TYPE_PROCESSING_DONE'}
  ];
}
